import React from "react";
import { anniversaryData } from "../../data/home";
import { mediaUrl } from "../../services/assetUrl";
import highlight from "./highlight";
import Reveal from "./Reveal";
import KnownFor from "./KnownFor";
import "./homeSections.css";

// "Celebrating 25 Years of Academic Excellence" — content from
// src/data/home/anniversary.json.
const Anniversary = ({ data, knownFor }) => {
  const { badge, heading, highlight: hl, description, image } = data || anniversaryData;

  return (
    <section className="anniversary-section" aria-labelledby="anniversary-title">
      {/* decorations */}
      <span className="anni__dots anni__dots--tl" aria-hidden="true" />
      <span className="anni__dots anni__dots--br" aria-hidden="true" />
      <span className="anni__radar anni__radar--l" aria-hidden="true" />
      <span className="anni__radar anni__radar--r" aria-hidden="true" />
      <span className="anni__plus anni__plus--1" aria-hidden="true" />
      <span className="anni__plus anni__plus--2" aria-hidden="true" />
      <span className="anni__plus anni__plus--3" aria-hidden="true" />

      <div className="container">
        <div className="anniversary-grid">
          <Reveal className="anniversary-media">
            <span className="anni__dots anni__dots--bl" aria-hidden="true" />
            <div className="anni__frame">
              <span className="anni__plate" aria-hidden="true" />
              <span className="anni__ring" aria-hidden="true" />
              <div className="anni__badge">
                <img src={mediaUrl(image)} alt={heading} loading="lazy" />
                <span className="anni__shine" aria-hidden="true" />
              </div>
            </div>
          </Reveal>

          <Reveal className="anniversary-content">
            <span className="anniversary-badge">{badge}</span>
            <h2 id="anniversary-title" className="anniversary-title">{highlight(heading, hl)}</h2>
            <p className="anniversary-desc">{description}</p>

            <KnownFor data={knownFor} />
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Anniversary;
